export function browserToIcon(browser) {
    let icon = '';
    switch (browser) {
        case 'Chrome':
            icon = 'fab fa-chrome fa-2x';
            break;
        case 'Firefox':
            icon = 'fab fa-firefox fa-2x';
            break;
        case 'Safari':
            icon = 'fab fa-safari fa-2x';
            break;
        case 'Internet Explorer':
            icon = 'fab fa-internet-explorer fa-2x';
            break;
        case 'Edge':
            icon = 'fab fa-edge fa-2x';
            break;
        default:
            icon = 'fad fa-browser';
            break;
    }
    return icon;
}
/**
 * Helper function to return browser information.
 * Source: https://stackoverflow.com/a/5918791/7977844
 *
 * @return string - browser name and version. Ex: "Chrome 80"
 */
export function sayswho() {
    const ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge?)\/(\d+)/);
        if (tem != null)
            return tem.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null)
        M.splice(1, 1, tem[1]);
    return M.join(' ');
}
/**
 * Helper method that gets browser name and version as a string and converts it to
 * an object as required by ILogInput.
 */
export function getBrowserType() {
    const info = sayswho().split(' ');
    return {
        type: info[0],
        version: info[1]
    };
}
